import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private apiUrl = environment.apiBaseUrl;
  private http = inject(HttpClient);

  // reconfirm signup email
  resendConfirmation(email: string): Observable<any> {
    return this.http.post(this.apiUrl + '/resend-confirmation', { email });
  }

  // create interface for any, like user for example
  postUser(email: string, password: string): Observable<any> {
    return this.http.post<any>(this.apiUrl + '/signup', { email: email, password: password })
  }

  signIn(email: string, password: string): Observable<any> {
    return this.http.post<any>(this.apiUrl + '/auth/login', { email: email, password: password })
  }

  resetPass(email: string): Observable<any> {
    return this.http.post<any>(this.apiUrl + '/reset-password', { email: email })
  }

  getStatus(): Observable<any> {
    return this.http.get(this.apiUrl + '/protected'); // No need to manually add headers
  }

  postImage(formData: FormData): Observable<any> {
    const token = localStorage.getItem('accessToken'); // Or cookie, etc.
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
    return this.http.post<any>(this.apiUrl + '/upload', formData, { headers })
  }
  constructor() { }
}

